import { IntuneDevice } from '../Intune/intune-device.model';
import { AgentDevice } from './agent-device.model';
import { IntuneUser } from '../Intune/intune-user.model';
import { ActivityLog } from './activity-log.model';
import { ActionAccessibility } from './action-accessibility.model';

export class Device {
  id!: string;
  agent?: AgentDevice | null;
  intune?: IntuneDevice | null;
  owner?: IntuneUser | null;
  activityLog?: ActivityLog[] | null;
  actions_accessibility?: ActionAccessibility[] | null;

  constructor(data?: Partial<Device>) {
    this.hydrateRelations(data);
  }

  private hydrateRelations(data?: Partial<Device>): void {
    const intuneSource = data?.intune ?? null;
    const agentSource = data?.agent ?? null;
    const activityLogSource = data?.activityLog ?? null;

    this.id = data?.id ?? intuneSource?.id ?? '';
    this.intune = intuneSource ? new IntuneDevice(intuneSource) : null;
    this.agent = agentSource ? new AgentDevice(agentSource) : null;
    this.activityLog = activityLogSource ? activityLogSource.map((log: ActivityLog) => new ActivityLog(log)) : null;
    this.owner = data?.owner ?? null;
    this.actions_accessibility = data?.actions_accessibility ?? null;
  }
}
